<template>
  <div :class="[$style.separator, vertical && $style.separatorVertical]" />
</template>

<script>
export default {
  name: 'b-separator',

  props: {
    vertical: Boolean,
  },
}
</script>

<style lang="scss" module>
.separator {
  background-color: var(--color-gray-14);
  width: 100%;
  height: 1px;
  margin-top: var(--b-gap-4);
  margin-bottom: var(--b-gap-4);

  &Vertical {
    width: 1px;
    height: 100%;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: var(--b-gap-4);
    margin-right: var(--b-gap-4);
  }
}
</style>
